import { persistStateTypes } from 'a/reducers/persistStateReducer';
import { GAME_ID } from '../../data';

const initialState = {
  levels: [],
  level: 0,
  question: 0,
  totalQuestions: 0,
  view: 0,
  correctAnswers: 0,
  correctFirstAnswers: 0,
  isFirstAnswerCorrect: true,
  lastLevelUnlocked: 0,
  onboardingWasPlayed: false,
  blockUserActions: false,
};

const levelReducer = (state = initialState, { gameId, type, payload, stateData }) => {
  if (gameId !== GAME_ID) {
    return state;
  }
  switch (type) {
    case 'LOAD_CURRICULUM':
      return {
        ...state,
        ...payload,
      };
    case 'SET_LEVEL':
      return {
        ...state,
        level: payload.level,
        correctAnswers: 0,
        correctFirstAnswers: 0,
        isFirstAnswerCorrect: true,
        question: 0,
        totalQuestions: payload.totalQuestions,
        blockUserActions: false,
      };
    case 'SET_TOTAL_QUESTIONS':
      return {
        ...state,
        totalQuestions: payload.totalQuestions,
      };
    case 'GET_NEXT_QUESTION':
      return {
        ...state,
        question: state.question + 1,
        isFirstAnswerCorrect: true,
        blockUserActions: false,
      };
    case 'GET_PROGRESS_VIEW':
      return {
        ...state,
        view: 0,
      };
    case 'GET_STORY_VIEW':
      return {
        ...state,
        view: 1,
      };
    case 'GET_LOADING_VIEW':
      return {
        ...state,
        view: 2,
      };
    case 'WRONG_ANSWER_GIVEN':
      return {
        ...state,
        isFirstAnswerCorrect: false,
      };
    case 'CORRECT_ANSWER_GIVEN':
      return {
        ...state,
        correctAnswers: state.correctAnswers + 1,
        correctFirstAnswers: state.isFirstAnswerCorrect ?
          state.correctFirstAnswers + 1 : state.correctFirstAnswers,
        blockUserActions: true,
      };
    case 'SET_LAST_LEVEL_UNLOCKED': {
      const { level, numLevels } = payload;
      return {
        ...state,
        lastLevelUnlocked: Math.min(level, numLevels - 1),
      };
    }
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE: {
      const { onboardingWasPlayed } = stateData[GAME_ID].GameData;
      return {
        ...state,
        onboardingWasPlayed: onboardingWasPlayed === undefined ? state.onboardingWasPlayed : onboardingWasPlayed,
      };
    }
    case 'ONBOARDING_WAS_PLAYED':
      return {
        ...state,
        onboardingWasPlayed: payload.onboardingWasPlayed,
      };
    case 'SET_BLOCK_USER_ACTIONS':
      return {
        ...state,
        blockUserActions: payload.blockUserActions,
      };
    default:
      return state;
  }
};

export default levelReducer;
